import axios from 'axios'
const baseUrl = '/api/u21'

const getEligibility = async (years, days) => {
  const response = await axios.get(`${baseUrl}?years=${years}&days=${days}`)
  return response.data
}

const getInfo = async () => {
  const response = await axios.get(baseUrl)
  return response.data
}

export default { getEligibility, getInfo }
